import React from "react";
import {
  AiOutlineLinkedin,
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import commonObj from '../../../utils/Common';
import FloatingWhatsApp from "./FloatingWhatsApp";

const Footer = () => {
  return (
    <div className="p-5 w-full bg-red-800 flex flex-wrap justify-center items-center text-center text-white footer-div-s absolute left-0 bottom-50 ">
      <p>{commonObj.getLabel('Buy_Sell_Made_Easy_Powered_by_Vstacks')}</p>
      {/**<p className="flex gap-3">
        <a href="https://github.com/SandhyaR1007">
          <AiFillGithub className="text-2xl text-gray-800" />
        </a>
        <a href="https://www.linkedin.com/in/sandhya-rajwanshi-a75b331b4/">
          {" "}
          <AiOutlineLinkedin className="text-2xl text-gray-800" />
        </a>
        <a href="https://twitter.com/SandhyaR1007">
          <AiOutlineTwitter className="text-2xl text-gray-800" />
        </a>
      </p>**/}
    <FloatingWhatsApp phoneNumber="97688202020" message="сайн уу" />
    </div>
  );
};

export default Footer;
